/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TGetUserTypeModel = IModel<IGetUserTypeRequest, TGetUserTypeResponse>;

export interface IGetUserTypeRequest {
  /** ID пользователя на Realty **/
  userId?: number | null;
}

export type TGetUserTypeResponse = IGetUserTypeResponse200 | IGetUserTypeResponse400;

export interface IGetUserTypeResponse200 extends IModelResponse<IGetUserTypeResponse> {
  statusCode: 200;
}

export interface IGetUserTypeResponse400 extends IModelResponse<IGetUserTypeResponseError> {
  statusCode: 400;
}

export interface IGetUserTypeResponse {
  /** Количество доступных для публикации объявлений как собственник **/
  announcementsPublishCount: number;
  /** Может ли опубликовать объявление как собственник **/
  canPublishAsHomeowner: boolean;
  /** Тип пользователя **/
  userType: EUserType;
}

export interface IGetUserTypeResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetUserTypeResponse | IGetUserTypeResponseError;

export enum EUserType {
  /** Собственник **/
  Homeowner = 'homeowner',
  /** Специалист **/
  Specialist = 'specialist',
  /** Неопределенный **/
  Undefined = 'undefined',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetUserTypeResponse): TResponse200;
  400(response: IGetUserTypeResponseError): TResponse400;
}
